/*
 * @Author: Veto [关于心伴部分 路由]
 * @Date: 2023-12-26 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2024-01-16 18:47:10
 */

import Privacy from '../views/xinban/privacy';
import User from '../views/xinban/user';
import LegalMale from '../views/xinban/legal_male';
import LegalFemale from '../views/xinban/legal_female';
import Pay from '../views/xinban/pay';
import Share from '../views/xinban/share';

import Help from '../views/warning/faq_tianmi';
import Vip from '../views/xinban/vip';
import ShareClose from '../views/common/close.vue';

import ErrorAccess from '../views/common/errorAccess.vue';


const router = {
    // '/xinban-privacy': Privacy,
    '/xinban-privacy': ErrorAccess,
    // '/xinban-user': User,
    '/xinban-user': ErrorAccess,
    '/xinban-help': Help,
    '/xinban-legal-male': LegalMale,
    '/xinban-legal-female': LegalFemale,
    '/xinban-pay': Pay,
    // '/xinban-share': Share,
    '/xinban-share': ShareClose,

    '/xinban-vip': Vip
};


export default router;